import { DocumentResponse, BeneDocsPaginatedResponse, SearchDocumentRequest } from '../../types/Document';
import { SearchAxiosInstance } from '../axios/axios';

export const getDocumentsFromSearchApi = async (params: SearchDocumentRequest) => {
  return await SearchAxiosInstance.get<BeneDocsPaginatedResponse<DocumentResponse>>('documents', { params }).then(
    ({ data }) => data
  );
};
